import { Produit } from "./Produit";
export class CommentaireProduit {
  id: any;
  commentaire: any;
  produit: any = Produit;
}